import { gql } from '@apollo/client';
import { OrderInfoPublic } from '../fragments';

export default gql`
  query order($id: ID) {
    order(id: $id) {
      ...OrderInfoPublic
    }
  }
  ${OrderInfoPublic}
`;
